module.exports = __webpack_public_path__ + "img/circle.f658f2e5.png";